module.exports = __webpack_public_path__ + "static/img/00d700a6397f85c7d4c48bdf4ece20cbc85fea12f55a-En0Urw_fw1200_1@2x.4d3466b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/serviceImg/service/00d700a6397f85c7d4c48bdf4ece20cbc85fea12f55a-En0Urw_fw1200_1@2x.png
// module id = 0r3X
// module chunks = 64